import React from "react";
import {
  MYPAGE_DATA_LIMIT,
  MAX_PAGINATION_LINK_NUM,
} from "../../../../utils/config";

const MypagePagination = ({
  tableData,
  limit,
  currentPage,
  setCurrentPage,
}) => {
  // 全ページ数
  const maxPageNum = Math.ceil(tableData.length / Number(limit));

  // ページクリック
  const handlePageClick = (page) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setCurrentPage(page);
  };

  return (
    <>
      {tableData.length > limit ? (
        <div className="c-pagination">
          <nav>
            <ul className="c-pagination-list">
              {/* 前ページ */}
              <>
                {currentPage !== 1 ? (
                  <li
                    className="c-pagination-list__item"
                    onClick={() => handlePageClick(currentPage - 1)}
                  >
                    <span className="c-pagination-list__link">
                      前の{MYPAGE_DATA_LIMIT}件
                    </span>
                  </li>
                ) : (
                  <></>
                )}
              </>
              {/* リンク表示の隙間(左) */}
              {/* <>{currentPage - MAX_PAGINATION_LINK_NUM > 1 ? <>…</> : <></>}</> */}
              {/* 現在のページより左側のリンク */}
              {Array.from({ length: currentPage - 1 }).map((_, i) => (
                <React.Fragment key={i + 1}>
                  {currentPage - MAX_PAGINATION_LINK_NUM <= i + 1 ? (
                    <li
                      onClick={() => handlePageClick(i + 1)}
                      className="c-pagination-list__item"
                    >
                      <span className="c-pagination-list__link">{i + 1}</span>
                    </li>
                  ) : (
                    <></>
                  )}
                </React.Fragment>
              ))}
              {/* 現在のページ */}
              <li className="c-pagination-list__item active">
                <span className="c-pagination-list__link">{currentPage}</span>
              </li>
              {/* 現在のページより右側のリンク */}
              {Array.from({ length: maxPageNum - currentPage }).map((_, i) => (
                <React.Fragment key={i + currentPage + 1}>
                  {currentPage + MAX_PAGINATION_LINK_NUM >=
                  i + currentPage + 1 ? (
                    <li
                      onClick={() => handlePageClick(i + currentPage + 1)}
                      className="c-pagination-list__item"
                    >
                      <span className="c-pagination-list__link">
                        {i + currentPage + 1}
                      </span>
                    </li>
                  ) : (
                    <></>
                  )}
                </React.Fragment>
              ))}
              {/* リンク表示の隙間(右) */}
              {/* <>
                {currentPage + MAX_PAGINATION_LINK_NUM < maxPageNum ? (
                  <>…</>
                ) : (
                  <></>
                )}
              </> */}
              {/* 次ページ */}
              <>
                {currentPage !== maxPageNum ? (
                  <li
                    className="c-pagination-list__item"
                    onClick={() => handlePageClick(currentPage + 1)}
                  >
                    <span className="c-pagination-list__link">
                      次の{MYPAGE_DATA_LIMIT}件
                    </span>
                  </li>
                ) : (
                  <></>
                )}
              </>
            </ul>
          </nav>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default MypagePagination;
